module.exports = __webpack_public_path__ + "media/images/registrations/info_version/background-2dc7a33b9e535d8c72974ef427b89a55.png";